<script setup lang="ts">
import logoUrl from '~/assets/images/logos/Teachme_Check_logo.svg?url'
</script>

<template>
  <img :src="logoUrl" width="100%" />
</template>

<style scoped lang="scss">
img {
  max-height: 1.5rem;
}
</style>
